import React from 'react'
import { ReactComponent } from './cog.svg'
import { MergeReactElementProps } from '../types'

interface SettingsProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', SettingsProps>

export const Settings = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#FFFFFF' } = props
    return <ReactComponent stroke={color} fill="none" ref={ref} {...props} />
  }
)
